import {mediaBreakpoints} from '@lightricks/react-design-system';

type BreakpointKey = keyof typeof mediaBreakpoints;

// Helper to create media query strings
const createMediaQuery = (breakpoint: BreakpointKey) =>
  `@media (max-width: ${mediaBreakpoints[breakpoint]}px)`;

// Create media query strings for each breakpoint
// eslint-disable-next-line import/prefer-default-export
export const media = {
  // Common breakpoints
  mobile: createMediaQuery('mobileUpperBound'),
  smallDesktop: createMediaQuery('smallDesktopUpperBound'),

  // All available breakpoints
  ...Object.keys(mediaBreakpoints).reduce(
    (acc, key) => ({
      ...acc,
      [key]: createMediaQuery(key as BreakpointKey),
    }),
    {}
  ),
};

// Example usage:
/*
import {Box, styled} from '@mui/material';
import {media} from '@/styles/mediaQueries';

const Container = styled(Box)`
  display: flex;
  gap: 36px;
  flex: 1;

  ${media.mobile} {
    max-width: 100%;
    flex-direction: column;
  }
`;

const Image = styled('img')`
  width: 575px;
  height: 575px;
  border-radius: 16px;
  object-fit: cover;

  ${media.mobile} {
    width: unset;
    height: unset;
    max-width: 100%;
    max-height: 100%;
  }
`;
*/
